module.exports = __webpack_public_path__ + "static/media/Diego-Tarek-de-Aristegui-interview.2c11738e.jpeg";